import { render, staticRenderFns } from "./HandleCompanyRoleModal.vue?vue&type=template&id=05dadc55&scoped=true&"
import script from "./HandleCompanyRoleModal.vue?vue&type=script&lang=ts&"
export * from "./HandleCompanyRoleModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05dadc55",
  null
  
)

export default component.exports